import { gql } from '@apollo/client'

const GET_COEYE_ORDERS = gql`
  query getCoeyeOrders($idCoeye: UUID!) {
    coeye(id: $idCoeye) {
      ordersByIdCoeye {
        nodes {
          status
          id
          orderArticlesByIdOrder {
            nodes {
              id
            }
          }
        }
      }
    }
  }
`

export default GET_COEYE_ORDERS
